function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { validateError } from '@/services/services';
import tasks from '@/js/tasks';
import axios from 'axios';
import setupInterceptors from '@/services/setupInterceptors';
var configuration = JSON.parse(process.env.VUE_APP_API_GTW_CONFIG);
//console.log(configuration)
// declare service gtw
var appApisGTW = null;
if (!configuration['tables_views']) {
  appApisGTW = axios.create({
    baseURL: 'http://localhost{PORT}'.replace('{PORT}', ':8091')
  });
} else {
  appApisGTW = axios.create({
    baseURL: process.env.VUE_APP_API_GTW.replace('{PORT}', ':8091')
  });
}

// appApisGTW.before(beforeMiddleware)
setupInterceptors(appApisGTW);
var loginObj = function loginObj() {
  return {
    email: window.userInfo.email,
    tokenId: window.userInfo.accessToken,
    localId: window.userInfo.localId
  };
};
var CONTROLLER_NAME = '/tables_views';
var DOMAIN_ASSIGNMENTS = '/pendings';
export default {
  listPendingApproval: function listPendingApproval(typeFlow, email) {
    var status = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "REVISION";
    var login = loginObj(window.userInfo.email, window.userInfo.accessToken, window.userInfo.localId);
    var body = {
      login: login,
      typeFlow: typeFlow,
      email: email,
      status: status
    };
    tasks.lockScreen.lock();
    return appApisGTW.post(CONTROLLER_NAME + DOMAIN_ASSIGNMENTS + '/list_pending_approval', body, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (res) {
      tasks.lockScreen.unlock();
      return res.data;
    }); /*.catch(err => {
        const message = '(getAssignments)'
        // const response = validateError(err, message)
        return validateError(err, message, () => { this.listPendingApproval(typeFlow, email) })
        })*/
  },
  approve: function approve(data) {
    var _this = this;
    var login = loginObj(window.userInfo.email, window.userInfo.accessToken, window.userInfo.localId);
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post(CONTROLLER_NAME + DOMAIN_ASSIGNMENTS + '/approve', body, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (res) {
      tasks.lockScreen.unlock();
      return res.data;
    }).catch(function (err) {
      var message = '(getAssignments)';
      // const response = validateError(err, message)
      return validateError(err, message, function () {
        _this.approve(data);
      });
    });
  },
  // Marca la tabla como authorization_type='automatic' y aprueba todas las solicitudes pendientes de esa tabla
  setAutomaticApproval: function setAutomaticApproval(data) {
    var _this2 = this;
    var login = loginObj(window.userInfo.email, window.userInfo.accessToken, window.userInfo.localId);
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post(CONTROLLER_NAME + DOMAIN_ASSIGNMENTS + '/approve_automatic', body, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (res) {
      tasks.lockScreen.unlock();
      return res.data;
    }).catch(function (err) {
      var message = '(setAutomaticApproval)';
      return validateError(err, message, function () {
        _this2.setAutomaticApproval(data);
      });
    });
  },
  reject: function reject(data) {
    var _this3 = this;
    var login = loginObj(window.userInfo.email, window.userInfo.accessToken, window.userInfo.localId);
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post(CONTROLLER_NAME + DOMAIN_ASSIGNMENTS + '/reject', body, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (res) {
      tasks.lockScreen.unlock();
      return res.data;
    }).catch(function (err) {
      var message = '(getAssignments)';
      // const response = validateError(err, message)
      return validateError(err, message, function () {
        _this3.reject(data);
      });
    });
  },
  changeMetadata: function changeMetadata(data) {
    var _this4 = this;
    var login = loginObj(window.userInfo.email, window.userInfo.accessToken, window.userInfo.localId);
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post(CONTROLLER_NAME + DOMAIN_ASSIGNMENTS + '/changeMetadata', body, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (res) {
      tasks.lockScreen.unlock();
      return res.data;
    }).catch(function (err) {
      var message = '(getAssignments)';
      // const response = validateError(err, message)
      return validateError(err, message, function () {
        _this4.changeMetadata(data);
      });
    });
  },
  massiveApprove: function massiveApprove(data) {
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post("".concat(CONTROLLER_NAME).concat(DOMAIN_ASSIGNMENTS, "/massive_approve"), body).then(function (response) {
      return response.data;
    }).finally(function () {
      tasks.lockScreen.unlock();
    });
  },
  reprocessAccess: function reprocessAccess(data) {
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post("".concat(CONTROLLER_NAME).concat(DOMAIN_ASSIGNMENTS, "/reprocess_access"), body).then(function (response) {
      return response.data;
    }).finally(function () {
      tasks.lockScreen.unlock();
    });
  },
  migrateEmailsBatch: function migrateEmailsBatch() {
    var _this5 = this;
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post("".concat(CONTROLLER_NAME).concat(DOMAIN_ASSIGNMENTS, "/migrate-emails-batch"), body).then(function (response) {
      tasks.lockScreen.unlock();
      return response.data;
    }).catch(function (err) {
      var message = '(migrateEmailsBatch) Error migrating emails batch';
      var response = validateError(err, message, function () {
        _this5.migrateEmailsBatch(data);
      });
      return response;
    }).finally(function () {
      tasks.lockScreen.unlock();
    });
  }
};